<template>
    <div class="tab_content">
        <div class="theme_tab-title">
            <span>{{ activeFormatInThemeTab.name }}</span>
            <span @click="showAllFormats" v-if="sessionToken.mode === 'merchant'">{{ $t('editorTabProjectsHide') }}</span>
        </div>
        <div class="tab_grid">
            <div
                v-if="projectsPage.length > 0"
                class="gallery_grid"
            >
                <div
                    v-for="(page, index) in projectsPage"
                    :key="index"
                    class="gallery_grid_item"
                    :style="boxStyle()"
                    v-show="page.pageData.thumbnailUrl !== null"
                >
                    <div
                        class="gallery_grid_item_img"
                        :style="{backgroundImage: `url(${page.pageData.thumbnailUrl})`}"
                        @click="showProjectPages(page.projectId)"
                    />
                </div>
            </div>
            <div 
                v-else
            >
                {{ $t('editorTabProjectsNoLayouts') }}
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import { RepositoryFactory } from '../../../repositories/repositoryFactory.js';
    const ProjectRepository = RepositoryFactory.get('projects');
    import { uuid } from 'vue-uuid';
    export default {
        data() {
            return {
                projectsPage: []
            }
        },
        computed: {
            ...mapGetters([
                'getProject',
                'getTemplateFormat'
            ]),
            ...mapState([
                'sessionToken',
                'activeFormatInThemeTab'
            ]),
            
        },
        watch: {
            getTemplateFormat: {
                immediate: false,
                deep: true,
                handler() {
                    this.$store.dispatch('SET_ACTIVE_FORMAT_IN_THEME_TAB', { id: this.getTemplateFormat.id, name: this.getTemplateFormat.name });
                    this.getFormatProjects(this.getTemplateFormat.id);
                }
            }
        },
        methods: {
            showAllFormats() {
                this.$store.dispatch('SET_ACTIVE_PROJECT_IN_THEME_TAB', null);
                this.$store.dispatch('SET_ACTIVE_FORMAT_IN_THEME_TAB', {});
                this.$store.dispatch('SET_ACTIVE_THEME_TAB', 'formatsList');
            },
            showProjectPages(projectId) {
                this.$store.dispatch('SET_ACTIVE_PROJECT_IN_THEME_TAB', projectId)
                this.$store.dispatch('SET_ACTIVE_THEME_TAB', 'activeProjectPages')
            },
            async getFormatProjects(formatId) {
                const headers = {
                    'api-key' : 'session',
                    'api-sign' : this.sessionToken.token
                }
                try {
                    const projectsList = await ProjectRepository.listProjects(formatId, headers);

                    let projectIds = [];

                    projectsList.data.data.entities.forEach(project => projectIds.push(project.id))

                    const promises = projectsList.data.data.entities.map(project => {
                        if (project.pages.length > 0) {
                            return ProjectRepository.getProjectPage(project.id, 1, headers);
                        }
                        
                    })

                    let pages = await Promise.all(promises);

                    pages = pages.filter(page => page !== undefined)

                    pages = pages.filter(page => page !== undefined).map((page, index) => {
                            const pageData = {
                                thumbnailUrl: page.data.data.thumbnailUrl,
                                thumbnailHeight: page.data.data.thumbnailHeight,
                                thumbnailWidth: page.data.data.thumbnailWidth
                            }
                            return {
                                pageData,
                                projectId: projectIds[index]
                            }
                        
                    })

                    this.projectsPage = pages;
                }
                catch (err) {
                    // Handle errors
                }
            },
            boxStyle() {
                const ratio = this.activeFormatInThemeTab.width / this.activeFormatInThemeTab.height;
                let widthNew, heightNew;

                if (ratio > 1) {
                    widthNew = 115;
                    heightNew = 115 / ratio;
                } else if (ratio < 1) {
                    heightNew = 155;
                    widthNew = 155 * ratio;
                } else {
                    heightNew = 115;
                    widthNew = 115;
                }

                return `width: ${widthNew}px; height: ${heightNew}px;`
            }
        },
        async created() {
            this.getFormatProjects(this.activeFormatInThemeTab.id);
        }
    }
</script>

<style lang="scss">
    .theme_tab-title {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }
    .gallery_grid {
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
    }
    .gallery_grid_item {
        width: 115px;
        height: 155px;
        margin: 8px 8px 8px 0;
        cursor: pointer;
        position: relative;
    }
    .gallery_grid_item_img {
        height: 100%;
        border-radius: 8px;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    @media (max-width: 1200px) {
        .gallery_grid_item {
            width: 180px;
            height: 230px;
            margin: 10px auto;
        }
    }
</style>